import { useCallback } from 'react';
import pathfinder from '@fiverr-private/pathfinder';
import { ModalOptions } from '@fiverr-private/identification_core';

interface UseWnwRedirectProps {
    variant: ModalOptions['variant'];
}

const IN_WNW_FLOW = 'in_wnw_flow';
const FORCE_BUYING_NAV = 'force_buying_nav';

export const useWnwRedirect = ({ variant }: UseWnwRedirectProps) => {
    const isWnwFlow = variant === 'wnw_direct' || variant === 'wnw_dashboard';

    const wnwAfterSigningSuccess = useCallback(() => {
        if (variant === 'wnw_direct') {
            const homepageQuery = { [IN_WNW_FLOW]: 'direct', [FORCE_BUYING_NAV]: 'true' };
            const homepageUrl = pathfinder('homepage', undefined, { query: homepageQuery });
            window.location.assign(homepageUrl);
            return;
        }
        if (variant === 'wnw_dashboard') {
            const sellerDashboardUrl = pathfinder('seller_dashboard_short_url');
            window.location.assign(sellerDashboardUrl);
        }
    }, [variant]);

    return isWnwFlow ? wnwAfterSigningSuccess : undefined;
};
